import { createRoot } from "react-dom/client";
import Logo from "@assets/images/quake_logo.svg";
import "~/index.css";
import { App } from "./app";

createRoot(document.getElementById("root")!).render(<App />);

if (document.head.querySelector("link[rel='icon']") === null) {
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = Logo;
  document.head.appendChild(link);
}
